<template>
  <el-drawer @reload="$reloadHandle"
             title="打印" size="80%"
             :before-close="handleClose"
             :visible.sync="drawer"
             direction="rtl"
             :modal-append-to-body="true"
             custom-class="demo-drawer"
             ref="drawer"
  >
    <div style="margin-top: 20px; text-align: center">
      <button @click="print()">打印</button>
    </div>
    <div id="print">
      <div id="divPrint" class="mainbox print" :model="formData" style="page-break-after:always;font-weight: bold;">
        <div class="container">
          <div class="top-img">
            <div><img src="statics/images/vatti.png"></div>
            <div class="title" >事故报告单</div>
            <!--<div><img src="statics/images/vatti2.png" ></div>-->

          </div>
          <div class="top2">
            <div><span class="span1">服务网点名称</span>:  <span class="span2">{{formData.siteName}}</span></div>
            <div><span class="span1">报告单号</span>:  <span class="span2">{{formData.reportNo}}</span></div>
            <div><span class="span1">打印日期</span>:  <span class="span2">{{nowDate}}</span></div>



          </div>

          <table border="1">
            <tbody>
            <tr>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 28%">
                <span style="margin-left: 5px;">工单号：{{formData.orderNo}}</span>
              </th>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">申请赔偿金额：{{formData.applyPayMoney}}
                </span></th>
              <th colspan="3"  rowspan="1"  class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">实际赔偿金额：{{formData.realPayMoney}}
                </span></th>
            </tr>
            <tr>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">网点联系人：{{formData.siteMan}}</span>
              </th>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">网点电话：{{formData.siteManMobile}}</span>
              </th>
              <th colspan="3"  rowspan="1"  class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">紧急程度：{{formData.urgencyTypeName}}</span>
              </th>
            </tr>
            <tr>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">事故类型：{{formData.accidentTypeName}}</span>
              </th>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">鉴定方式：{{formData.identifyTypeName}}</span>
              </th>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;" v-if="formData.qualityType===1">是否质量问题：是</span>
                <span style="margin-left: 5px;" v-else>是否质量问题：否</span></th>
            </tr>

            <tr>
              <th colspan="3"  rowspan="1" class="wid180" style="width: 25%">
                <span style="margin-left: 5px;">完工日期：{{formData.completeTime}}</span>
              </th>
              <th colspan="3"  rowspan="1" class="wid180" style="width: 25%">
                <span style="margin-left: 5px;">回执单号：{{formData.receiptNo}}</span>
              </th>
              <th colspan="3"  rowspan="1"  class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">快递单号：{{formData.logisticsNo}}</span>
              </th>
            </tr>
            <tr>
              <th colspan="9"  rowspan="1" class="wid180" style="width: 90%">
                <span style="margin-left: 5px;">报告描述：{{formData.reportRemark}}</span>
              </th>

            </tr>
            <tr>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">用户姓名：{{formData.userName}}</span>
              </th>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">用户电话：{{formData.userMobile}}</span>
              </th>
              <th colspan="3"  rowspan="1"  class="wid100" style="width: 25%">
                <span style="margin-left: 5px;"></span>
              </th>
            </tr>
            <tr>
              <th colspan="9"  rowspan="1" class="wid180" style="width: 90%">
                <span style="margin-left: 5px;">用户地址：{{formData.userProvice}}{{formData.userCity}}{{formData.userCounty}}{{formData.userTown}}{{formData.userAddress}}</span>
              </th>

            </tr>

            <tr>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">产品编码：{{formData.itemCode}}</span>
              </th>
              <th colspan="3"  rowspan="1" class="wid180" style="width: 25%">
                <span style="margin-left: 5px;">产品名称：{{formData.itemName}}</span>
              </th>
              <th colspan="3"  rowspan="1"  class="wid100" style="width: 30%">
                <span style="margin-left: 5px;">产品条码：{{formData.barcode}}</span>
              </th>
            </tr>
            <tr>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">产品大类：{{formData.bigCategoryName}}</span>
              </th>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">产品小类：{{formData.smallCategoryName}}</span>
              </th>
              <th colspan="2"  rowspan="1" class="wid180" style="width: 25%">
                <span style="margin-left: 5px;">购买日期：{{formData.buyDate}}</span>
              </th>
            </tr>
            <tr>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%">
                <span style="margin-left: 5px;">气源名称：{{formData.gasTypeName}}</span>
              </th>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%"><span style="margin-left: 5px;"></span></th>
              <th colspan="3"  rowspan="1" class="wid100" style="width: 25%"><span style="margin-left: 5px;"></span></th>
            </tr>

            </tbody>
          </table>

        </div>

      </div>
    </div>
  </el-drawer>
</template>

<script>
import printJS from "print-js";
import api from "@/api/projectApi";
export default {
  name: "printing",
  props: ['multi','param','orderId','orderIds'],
  created() {
    this.currentTime()
    if (this.orderIds!=null){
      this.dataIds = this.orderIds;
    }
    if (this.orderId != null ) {
      this.dataId = this.orderId
    }
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      nowDate:'',
      dataId:'',
      dataIds:[],
      drawer: true,
      orderDates:[],
      formData:{

      }
    };

  },
  methods: {
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth() + 1;
      let day = date.getDate();
      //如果格式是MM则需要此步骤，如果是M格式则此处注释掉
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day<=9){
        day = "0" + day;
      }
      let strDate = year + "-" + month+"-"+day;
      this.nowDate = strDate
    },
    getData(){
      this.$http({
        url: api.wkAccidentReport.getDataUrl + this.dataId,
        method: 'get',
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.formData = response.data.data
        this.formData.buyDate = this.formatDate(this.formData.buyDate)
      })
    },
    formatDate(date) {
      let d = new Date(date);
      let day = d.getDate();
      let month = d.getMonth() + 1;
      let year = d.getFullYear();

      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    },
    print() {
      printJS({
        printable: "print", // 标签元素id
        type: "html", // 打印类型
        targetStyles: ["*"],
        style: "@page {margin:0 10mm};", // 可选-打印时去掉眉页眉尾
        ignoreElements: ["no-print"], // 接受打印父 html 元素时应忽略的 html id 数组。
        properties: null,
      });
    },
    handleClose() {
      this.drawer = false;
      this.$emit('closePrint', 1)
    }
  },
};
</script>

<style lang="scss" scoped>
#print {
  .container table {
    width: 1000px;
    /* text-align: center; */
    border-color: #000;
    border-collapse: collapse;
    color: black;
  }
  .top2,.down_,.top-img{
    color: black;
  }

  thead {
    color: #000000;
    /* background: rgb(0, 112,192); */
  }

  tbody {
    font-size: 14px;
  }

  tbody td, th {
    padding: 5px 0;
  }

  .wid50 {
    width: 50px;
    text-align: left;
  }

  .wid100 {
    /* width: 100px; */
    text-align: left;
  }
  .wid180 {
    /* width: 180px; */
    text-align: left;
  }
  td {
    margin: 0;
    padding: 0;
    /*font-weight: 300!important;*/
    font-weight: bold!important;

  }

  a {
    text-decoration: none;
    color: #08acee;
  }

  button {
    outline: 0;
  }

  img {
    border: 0;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
  }

  li {
    list-style: none;
  }

  a {
    color: #666;
  }

  .clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
  }
  .container{
    width: 1100px;
    margin: 100px auto;
    border: 1px solid #f1f1f1;
    padding: 0 50px 10px;
    /* background-color: #e9e9e9; */
  }

  .top-img{
    display: flex;
    position: relative;
    height: 100px;
    margin-top: 20px;
  }
  .title{
    font-size: 24px;
    font-weight: 600;
    margin: 0 200px 0 170px;
  }

  .img2{
    margin-left: 100px;
  }
  .top2{
    display: flex;
    padding: 5px;
    justify-content: space-between;
  }
}
</style>
